import React, {useState, useMemo, useEffect} from 'react';
import * as config from '../../config.js';
import { useSelector, useDispatch } from 'react-redux';
import {useDropzone} from 'react-dropzone'
import styled from 'styled-components';
import axios from 'axios';
import {
  getLastUrl,
  addColors,
  clearAllColor
} from '../color/colorSlice';
import {
    getWorkId,
    setResize,
    clearAllForm,
    changeWorkId
} from '../formData/formDataSlice';
import {
  Table, 
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import PaletteIcon from '@mui/icons-material/Palette';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  height:"80%",
  boxSizing: "border-box",
  display:"table",
  width:"100%"
};
  
const activeStyle = {
  borderColor: config.DABEEO_COLOR
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

const UploadImage = styled.div`
  background-image:  ${ (props) => "url("+props.lastUrl+")" }
`;

export function Upload(props) {
  const dispatch = useDispatch();

  const [files, setFiles] = useState([]);
  const [paletteClick, setPaletteClick] = useState(false);
  const [paletteSize, setpaletteSize] = useState(30);
  const [backgroundImage, setbackgroundImage] = useState('');
  const [base64, setBase64] = useState('');
  const [loading, setLoading] = React.useState(false);
  const lastUrl = useSelector(getLastUrl);  
  const workId = useSelector(getWorkId);
  
  const changeInput = (e) => {
    const { value } = e.target;
    const onlyNumber = parseInt(value.replace(/[^0-9]/g, ''));
    setpaletteSize(onlyNumber);
  };
  

  useEffect(() =>{

    if(paletteClick){
      let base64Str = base64;
          base64Str = base64Str.replace(/^data:image\/[a-z]+;base64,/, "");
          setBase64(base64Str);
      axios.post(config.SERVER_API+'api/layout-parser/recommend', {
          // "work-id": uuidv4(),
          "work-id": workId,
          "image": base64Str,
          "parameters": {
            "layout-recommender": {
              "k": paletteSize,
              // "resize": 500,
              // "open-kernel-size": 7,
              // "min-layout-area": 50,
              // "merge-color-distance": 10,
              // "thumbnail-size": 50
            }
          }
      })
      .then(function (response) {
          dispatch(addColors(
              response.data.result.layouts
          ));

          setLoading(false);
          setPaletteClick(false);
      })
      .catch(function (error) {
          console.log(error);
          setLoading(false);
      });
    }
    
  }, [workId]);

  function getPalette() {
    setPaletteClick(true);
    setLoading(true);
    dispatch(clearAllColor());
    dispatch(clearAllForm());
    dispatch(changeWorkId());
    //useEffect 에서 workId가 변경되면 axios실행 
  }

  const {acceptedFiles, 
    getRootProps, 
    getInputProps, 
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept: 'image/*',
    onDrop: acceptedFiles => {
      acceptedFiles.map(file => {
          const reader = new FileReader();
          reader.onload = (event) => {
              setFiles(acceptedFiles.map(file => {
                setbackgroundImage(URL.createObjectURL(file));
                setBase64(event.target.result);
              }));
              let img = new Image();      
              img.src = event.target.result;
              img.onload = function () {
                  let w = this.width;
                  let h = this.height;
                  dispatch(setResize([w,h]));

                  dispatch(clearAllColor());
                  dispatch(clearAllForm());
              }
          };
          reader.readAsDataURL(file);
      });
    }
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {}),
    // ...(backgroundImage ? {backgroundImage : backgroundImage} : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept,
    backgroundImage
  ]);
  
  const descStyle = {
    color: config.DABEEO_COLOR,
    fontWeight:'bolder',
    display : backgroundImage == '' ? "table-cell" : "none",
    verticalAlign:"middle",
  }

  return (
    <section className="container left_section">
      <UploadImage {...getRootProps({ className: 'dropzone', style})} lastUrl={lastUrl === '' ? backgroundImage : lastUrl}>
        <input {...getInputProps()} />
        <p style={ descStyle }>1. Drag 'n' drop some files here, or click to select files</p>
      </UploadImage>

      <TableContainer sx={{  }} component={Paper}>
        <Table sx={{  }} aria-label="simple table">
          <TableBody>
              <TableRow key={1}>
                <TableCell component="th" scope="row">
                  <TextField
                    fullWidth
                    label="palette size (default: 30)"
                    value={paletteSize}
                    onChange={(e) => changeInput(e)}
                  />
                </TableCell>
                <TableCell scope="row">
                  <LoadingButton
                    fullWidth
                    disabled={backgroundImage == '' ? true : false}
                    onClick={getPalette}
                    endIcon={<PaletteIcon />}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained"
                  >
                    2. Get Palette
                  </LoadingButton>
                </TableCell>

              </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </section>
  );
}
  
